export default {
  tiles: [
    {
      id: 0,
      title: 'POPULATION',
      copy: '22% of adults in the US are unbanked or underbanked<sup>*</sup> with no credit and little cash in their pockets. This group is more likely to have low income, less education, or be a part of an underrepresented group.',
      imageAlt: '',
      image:
        'https://www.nerdwallet.com/cdn/company/2021/csr/CSR2.0_collage-01.jpg',
    },
    {
      id: 1,
      title: 'PROBLEM',
      copy: 'When these unbanked Americans try to start a business, buy a home, or pay for an emergency expense – steps towards long-term wellbeing for themselves, their families, and their communities, they lack proper options.',
      imageAlt: '',
      image:
        'https://www.nerdwallet.com/cdn/company/2021/csr/CSR2.0_collage-02.jpg',
    },
    {
      id: 2,
      title: 'COST',
      copy: 'Forced to turn to predatory financial services that can come with higher fees and interest, the unbanked or underbanked have paid $140 billion in unnecessary costs.<sup>**</sup>',
      imageAlt: '',
      image:
        'https://www.nerdwallet.com/cdn/company/2021/csr/CSR2.0_collage-03.jpg',
    },
  ],
};
